import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            bankAccount: 'themes/player-bank/bankAccount',
        }),
    },
    methods: {
        onSelectedBankAccount(id) {
            if (this.selectedBankId === id) {
                this.selectedBankId = null
                this.pleaseSelectedBankId = true
            } else {
                this.selectedBankId = id
                this.pleaseSelectedBankId = false
            }
        },
    },
}
